<template>
  <div class="sectionContainer">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SectionContainer'
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/mixins';

.sectionContainer {
  @include bpOnlyPc() {
    max-width: 900px;
    margin: auto;
    padding: 140px 20px;
  }
  @include bpOnlySp() {
    margin: auto;
    padding: 96px 32px;
  }
}
</style>
